module.exports = __webpack_public_path__ + "img/clock.7e42d9cd.svg";